<po-page-list #poPageListComponent
  p-title="Romaneio Mercado Interno - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row po-mb-1">
    <po-button class="po-xl-2 po-lg-2 po-md-3 po-mb-2"
      p-type="default"
      p-label="Novo Romaneio"
      (p-click)="openModalNovoRomaneio()">
    </po-button>
    <po-button class="po-xl-2 po-lg-2 po-md-3 po-mb-2"
      p-danger="true"
      p-label="Excluir Rom."
      (p-click)="openDialogConfirmarExcluirRomaneiosSelecionados()"
      [p-disabled]="bloqueiaAcao || permissaoExcluir">
    </po-button>
    <po-button class="po-xl-2 po-lg-2 po-md-3 po-mb-2"
      p-kind="secondary"
      p-label="Res. Excel"
      (p-click)="bttnExcel()"
      [p-disabled]="bloqueiaAcao">
    </po-button>
    <po-button class="po-xl-2 po-lg-2 po-md-3 po-mb-2"
      p-label="Imprimir PDF"
      p-icon="po-icon-print"
      (p-click)="bttnEtiquetaClienteSelecionados()"
      [p-disabled]="bloqueiaAcao">
    </po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-striped]="true"
    [p-selectable]="true"
    [p-selectable-entire-line]="false"
    (p-selected)="selecionaRegistro()"
    (p-unselected)="selecionaRegistro()"
    (p-all-selected)="selecionaRegistro()"
    (p-all-unselected)="selecionaRegistro()"
    [p-actions]="tabelaPrincipalAction"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-hide-columns-manager="false"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:">
    </po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:">
    </po-datepicker>
    <po-input
      class="po-md-6"
      name="CZ00COD"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00COD"
      p-label="Código Romaneio"
      [p-maxlength]="6"
    ></po-input>
    <po-select
      class="po-md-6"
      name="CZ00STATUS"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00STATUS"
      p-label="Status"
      [p-options]="varStatus"
    ></po-select>
    <po-input
      class="po-md-6"
      name="CZ00CLIENT"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00CLIENT"
      p-label="Cliente"
      [p-maxlength]="6"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ00PROCES"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00PROCES"
      p-label="Processo"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CEE7PEDIDO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CEE7PEDIDO"
      p-label="P.O. Number"
    ></po-input>
  </form>
</po-modal>

<po-modal #criarRomaneioModal p-title="Novo Romaneio MI" [p-primary-action]="criarRomaneioAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-12"
      name="grupoCliente"
      [(ngModel)]="novoCadastroRomaneio.CZ00GRPVEN"
      p-field-label="CACYDESCRI"
      p-field-value="CACYGRPVEN"
      p-label="Grupo Cliente"
      [p-columns]="columnsGrupoClienteFilters"
      [p-field-format]="fieldFormaterGrupoClienteFilters"
      [p-filter-service]="grupoClienteLookupService"
      [p-advanced-filters]="advancedGrupoClienteFilters"
      [p-literals]="{ modalTitle: 'Grupo Cliente' }"
    ></po-lookup>
  </form>
</po-modal>




<po-modal #editarDadosEtapaModal p-title="Editar Dados Romaneio" [p-primary-action]="salvarDadosRomaneio">
  <form #f="ngForm">
    <po-divider class="po-md-12" p-label="1ª Etapa"></po-divider>
    <po-lookup
      class="po-md-6"
      name="CZ00CAMICP"
      [(ngModel)]="alteraRomaneio.CZ00CAMICP"
      p-field-label="CA4NOME"
      p-field-value="CA4COD"
      p-label="Truck Company / Transportadora"
      [p-columns]="columnsTransportadoraFilters"
      [p-field-format]="fieldFormaterTransportadoraFilters"
      [p-filter-service]="transportadoraService"
      [p-advanced-filters]="advancedTransportadoraFilters"
      [p-literals]="{ modalTitle: 'Transportadora' }"
    ></po-lookup>
    <po-input
      class="po-md-6"
      name="CZ00PROCES"
      [(ngModel)]="alteraRomaneio.CZ00PROCES"
      p-label="Process / Processo"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ00NCERT"
      [(ngModel)]="alteraRomaneio.CZ00NCERT"
      p-label="Nº Certificado"
    ></po-input>
    <po-number
      class="po-md-6"
      name="NZ00PESLIM"
      [(ngModel)]="alteraRomaneio.NZ00PESLIM"
      p-label="Limit Weight / Peso Limite"
    ></po-number>
    <po-divider class="po-md-12" p-label="2ª Etapa"></po-divider>
    <po-lookup
      class="po-md-6"
      p-label="Truck Plate / Placa Veículo"
      name="CZ00PLACA"
      [(ngModel)]="alteraRomaneio.CZ00PLACA"
      p-field-value="CDA3PLACA"
      p-field-label="CDA3DESC"
      [p-columns]="veiculoColumnsFilters"
      [p-field-format]="veiculoFieldFormaterFilters"
      [p-filter-service]="veiculoLookupService"
      [p-advanced-filters]="veiculoAdvancedFilters"
      [p-literals]="{ modalTitle: 'Veículo' }"
      [p-required]="true"
      [p-disabled]="bloqueiaPlaca"
    ></po-lookup>
    <po-input
      class="po-md-6"
      name="CZ00COTNER"
      [(ngModel)]="alteraRomaneio.CZ00COTNER"
      p-label="Container / Container"
    ></po-input>
    <po-number
      class="po-md-6"
      name="NZ00TARA"
      [(ngModel)]="alteraRomaneio.NZ00TARA"
      p-label="Tare / Tara"
    ></po-number>
    <po-input
      class="po-md-6"
      name="CZ00SELOD"
      [(ngModel)]="alteraRomaneio.CZ00SELOD"
      p-label="Definitive Seal / Lacre Definitivo"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ00SELOP"
      [(ngModel)]="alteraRomaneio.CZ00SELOP"
      p-label="Provisional Seal / Lacre Provisório"
    ></po-input>
    <po-datepicker class="po-md-3"
      name="DZ00DTACAR"
      p-label="Data de Carregamento"
      [(ngModel)]="alteraRomaneio.DZ00DTACAR"
    ></po-datepicker>
    <po-input class="po-md-3"
      name="CZ00HRACAR"
      p-label="Hora do Carregamento"
      [(ngModel)]="alteraRomaneio.CZ00HRACAR"
      p-mask="99:99:99"
    ></po-input>
    <po-divider class="po-md-12" p-label="Outros dados"></po-divider>
    <po-input
      class="po-md-6"
      name="CZ00FRETCP"
      [(ngModel)]="alteraRomaneio.CZ00FRETCP"
      p-label="Shipping Company"
    ></po-input>
  </form>
</po-modal>

<po-modal #modalValidaSenha p-title="Atenção!" p-size="sm" p-hide-close="true">
  <form #formValidaSenha="ngForm">
    <po-password class="po-md-12"
      name="senha"
      p-label="Digite a sua senha antes de confirmar."
      [(ngModel)]="senhaAcesso"
      p-maxlength="6"
      p-minlength="6"
      p-mask="999999"
      [p-required]="true">
    </po-password>
  </form>
  <po-modal-footer>
    <po-button p-label="Voltar"     p-danger="true"   (p-click)="fecharModalSenha()"></po-button>
    <po-button p-label="Confirmar"  p-kind="primary"  (p-click)="confirmaModalSenha()" [p-disabled]="formValidaSenha.invalid"></po-button>
  </po-modal-footer>
</po-modal>
